import React from 'react';
import shallowEqual from 'shallowequal';
import Input from './Input';
import TextArea from './TextArea';
import { IABSInputProps } from './interface';
import { defaultResult, validatorWithMsg } from '../../utils/Validator';
import commonUtils from '../../utils/commonUtils';
import { Input as AntdInput } from 'antd';
interface IABSInputState {
  inputValue?: any;
  result?: any;
  emptyClassName: string;
}

class ABSInput extends React.Component<IABSInputProps, IABSInputState> {
  static defaultProps = {
    isSuffix: false,
    size: 'default',
    disableResize: false,
    rules: []
  };

  inputRef: React.RefObject<AntdInput> = React.createRef();

  constructor(props: any) {
    super(props);
    const { defaultValue, value } = props;
    if (value === undefined) {
      this.state = {
        inputValue:
          defaultValue === undefined || defaultValue === null
            ? ''
            : defaultValue,
        result: defaultResult,
        emptyClassName: ''
      };
    } else {
      this.state = {
        result: defaultResult,
        emptyClassName: ''
      };
    }
  }

  componentWillReceiveProps(nextProps: IABSInputProps) {
    const { defaultValue, value } = nextProps;
    if (value === undefined) {
      if (!shallowEqual(defaultValue, this.props.defaultValue)) {
        this.setState({
          inputValue:
            defaultValue === undefined || defaultValue === null
              ? ''
              : defaultValue,
          result: defaultResult,
          emptyClassName: ''
        });
      }
    }
    if (nextProps.emptyClassName) {
      this.setState({ emptyClassName: nextProps.emptyClassName });
    }
  }

  /**
   * 引用的方法
   */

  validatorValue(value?: any) {
    const { title, rules = [], required, value: propsValue } = this.props;
    if (!rules.length && !required) {
      return defaultResult;
    }
    let newRules = commonUtils.deep(rules);
    if (required) {
      newRules.unshift({ required, message: '请输入' + (title || '内容') });
    }
    const { inputValue } = this.state;
    const result = validatorWithMsg(value || propsValue || inputValue, newRules);
    this.setState({ result });
    return result;
  }

  getValue = (valueType?: 'int') => {
    if (valueType === 'int') {
      return this.getIntValue();
    }
    return this.state.inputValue;
  };

  reset = () => {
    const { defaultValue } = this.props;
    const inputValue = defaultValue === undefined || defaultValue === null ? '' : defaultValue;
    this.setState({ inputValue, result: defaultResult });
  };

  setValue(val: any) {
    this.setState({ inputValue: val, result: defaultResult });
  }

  render() {
    const {
      type,
      placeholder,
      disabled,
      defaultValue,
      size,
      prefix,
      isSuffix,
      className,
      addonAfter,
      addonBefore,
      style,
      autosize,
      height,
      disableResize,
      areaMaxLen,
      onCopy,
      desc,
      title,
      required,
      labelWidth,
      contentWidth,
      removePaddingLeft,
      removeMarginBottom,
      bottomTextClassName,
      value: propsValue,
      isVertical,
      onKeyUp,
      onPaste,
    } = this.props;
    const { inputValue, emptyClassName, result } = this.state;
    const value = propsValue !== undefined ? propsValue : inputValue;
    const commonProps = {
      style,
      value,
      defaultValue,
      placeholder,
      disabled,
      className,
      onChange: this.onChange,
      result,
      removeMarginBottom,
      removePaddingLeft,
      desc,
      title,
      required,
      labelWidth,
      contentWidth,
      isVertical
    };
    if (type === 'textarea') {
      return (
        <TextArea
          {...commonProps}
          autosize={autosize}
          height={height}
          onCopy={onCopy}
          disableResize={disableResize}
          areaMaxLen={areaMaxLen}
          bottomTextClassName={bottomTextClassName}
        />
      );
    }
    return (
      <Input
        {...commonProps}
        emptyClassName={emptyClassName}
        prefix={prefix}
        type={type}
        size={size}
        isSuffix={isSuffix}
        addonBefore={addonBefore}
        addonAfter={addonAfter}
        onPressEnter={this.onPressEnter}
        onBlur={this.onBlur}
        onFocus={this.onFocus}
        onDelete={this.onDelete}
        onKeyUp={onKeyUp}
        onPaste={onPaste}
        refs={this.inputRef}
      />
    );
  }

  /**
   * 事件
   */

  onChange = (e: any) => {
    const { type, areaMaxLen, onChange, value } = this.props;
    const inputValue = e.target.value;
    let newValue = inputValue;

    if (areaMaxLen && inputValue.length > areaMaxLen && type === 'textarea') {
      newValue = inputValue.substr(0, areaMaxLen);
    }
    if (value === undefined) {
      this.setState({ inputValue: newValue}, () => {
        this.validatorValue();
      });
    }
    if (onChange) {
      onChange(newValue);
    }
  };

  onPressEnter = (e: any) => {
    const { onPressEnter } = this.props;
    const inputValue = e.target.value;
    if (onPressEnter) {
      onPressEnter(inputValue);
      return;
    }
    this.setState({ inputValue });
  };

  // 失去焦点回调
  onBlur = (e: any) => {
    const { onBlur } = this.props;
    if (onBlur) {
      const flag = onBlur(e.target.value);
      if (typeof flag === 'undefined') {
        return;
      }
      this.setState({ emptyClassName: flag });
    }
  };
  // 获取焦点回调
  onFocus = (e: any) => {
    const { onFocus } = this.props;
    const inputValue = e.target.value;
    if (onFocus) {
      onFocus(inputValue);
    }
  };

  onDelete = (e) => {
    this.setState({ inputValue: '' });
    const { onDelete } = this.props;
    if (onDelete) {
      onDelete();
    }
  }
  
  // 触发获取焦点
  focus = () => {
    if (this.inputRef && this.inputRef.current) {
      this.inputRef.current.focus();
    }
  }
  // 触发失去焦点
  blur = () => {
    if (this.inputRef && this.inputRef.current) {
      this.inputRef.current.blur();
    }
  }
  
  private getIntValue = () => {
    const intValue = parseInt(this.state.inputValue, 10);
    if (isNaN(intValue)) {
      return 0;
    }
    return intValue;
  };
}

export { IABSInputProps };
export default ABSInput;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSInput/index.tsx